module.exports = __webpack_public_path__ + "static/media/Promotion.cd40ae38.png";